<div class="header p-3 pt-4" *ngIf="currentPspType == pspTypeEnum.PspPatient">
  <h3>Patient Subscription</h3>
  <p>
    You are checking this user subscriptions in PSPs as a patient only.
    <br />
    If the user has PSPs subscriptions as a caregiver too, please check the
    caregivers section.
  </p>
</div>
<div class="header p-3 pt-4" *ngIf="currentPspType == pspTypeEnum.PspCareGiver">
  <h3>Care Giver Subscription</h3>
  <p>
    You are checking this user subscriptions in PSPs as a care giver only.
    <br />
    If the user has PSPs subscriptions, please check the
    patient section.
  </p>
</div>

<div class="card-body">
  <!-- <h2> Profile details</h2> -->
  <div class="switch-to-cargiver d-flex justify-content-center p-4"
    *ngIf="currentPspType == pspTypeEnum.PspPatient && isHaveCareGiverSubscription">
    <span>Looks like this patient is a caregiver too. </span>
    <a (click)="switchPspType(pspTypeEnum.PspCareGiver)"> <b> Switch to Care Giver Profile↗</b></a>
  </div>
  <div class="switch-to-cargiver d-flex justify-content-center p-4" *ngIf="currentPspType == pspTypeEnum.PspCareGiver">
    <span>Looks like this patient has subscriptions too. </span>
    <a (click)="switchPspType(pspTypeEnum.PspPatient)"> <b> Switch to Patient Profile↗</b></a>
  </div>

  <div class="address-container d-flex flex-wrap mt-5" *ngIf="currentPspType == pspTypeEnum.PspPatient">
    <div class="add-address address-card d-flex flex-column justify-content-center align-items-center"
      [routerLink]="['/patient-details', patientId, 'enroll-to-another-program']">
      <!-- (click)="openNotificationModal(addressSubModal)" -->
      <span class="mb-3">
        <i class="icon-add-address"></i>
      </span>
      <h3 class="cta-address">
        Enroll Patient to another program
      </h3>
    </div>
  </div>

  <div class="mt-5">
    <div class="mt-5" *ngIf="subscriptionArray.pending.length > 0">
      <h2>Pending Subscriptions</h2>
      <div class="address-container d-flex flex-wrap">
        <div class="address-card" *ngFor="let sub of subscriptionArray.pending; let i = index">
          <div class="card-header">
            <div class="more-menu-trigger row d-flex justify-content-between pr-3 pl-3">
              <h3>{{ sub?.program.name }}</h3>
              <span (click)="openMenuItem('pending', i)"><i class="icon-show-more"></i></span>
              <div class="more-menu" *ngIf="moreMenuItems.pending[i]">
                <ul>
                  <li [routerLink]="['/psp', 'pending-patient', sub.id]">
                    <span><i class="icon-view"></i></span>View Details
                  </li>
                  <li *ngIf="showRocheFields(sub.program.companyId);" (click)="openSubscriptionHistoryModal(sub)">
                    <span><i class="icon-history"></i></span> Subscription History
                  </li>
                  <li (click)="previewDocument(sub?.id)">
                    <span><i class="icon-preview-document"></i></span>Preview Documents
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row my-2">
              <div class="col-md-6">
                <label for="subDate">Submission Date</label>
                <span id="subDate">{{ sub?.creationDate | date: "MMM d" }}|{{
                  sub?.creationDate | date: "h:mm a"
                  }}</span>
              </div>
              <div class="col-md-6">
                <label for="physName">Physician Name</label>
                <span id="physName">{{ sub?.doctor?.name || "--" }}</span>
              </div>
            </div>
            <div *ngIf="showRocheFields(sub?.program.companyId)">
              <div class="row my-2" >
                <div class="col-md-6">
                  <label for="subscription-history">Subscription History</label>
                  <span id="subscription-history" [title]="(sub?.subscriptionHistory||'')" class="subscription-history"
                  [style.direction]="isArabic(sub?.subscriptionHistory) ? 'rtl' : 'ltr'">{{ sub?.subscriptionHistory || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="psp-code">Psp Code</label>
                  <span id="psp-code">{{ sub?.pspCode || "--" }}</span>
                </div>
              </div>
              <div class="row my-2" >
                <div class="col-md-6">
                  <label for="roche-subscription-code">Roche Subscription Code</label>
                  <span id="roche-subscription-code">{{ sub?.doctorCode + '-' + sub?.pspCode || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="doctor-code">Doctor Code</label>
                  <span id="doctor-code">{{ sub?.doctorCode || "--" }}</span>
                </div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-6" *ngIf="!showRocheFields(sub?.program.companyId)">
                <label for="hospital">Hospital/Clinic Name</label>
                <span id="hospital">{{ sub?.hospital?.name || "--" }}</span>
              </div>
              <div class="col-md-6" *ngIf="currentPspType == pspTypeEnum.PspCareGiver">
                <label for="hospital">Care Receiver Name</label>
                <span id="hospital">{{ sub?.careReceiverName || "--" }}</span>
              </div>
              <div class="col-md-6">
                <label for="companyName">Company Name</label>
                <span id="companyName">{{ sub?.program?.companyName || "" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5" *ngIf="subscriptionArray.active.length > 0">
      <h2>Active Subscriptions</h2>
      <div class="address-container d-flex flex-wrap">
        <div class="address-card" *ngFor="let sub of subscriptionArray.active; let i = index">
          <div class="card-header">
            <div class="more-menu-trigger row d-flex justify-content-between pr-3 pl-3">
              <h3>{{ sub?.program.name }}</h3>
              <div *ngIf="sub.statusId === pspSubscriptionStatusEnum.Suspended">
                <span class="badge badge-warning">Flagged</span>
              </div>
              <span (click)="openMenuItem('active', i)"><i class="icon-show-more"></i></span>
              <div class="more-menu" *ngIf="moreMenuItems.active[i]">
                <ul>
                  <li (click)="openFlaggingReasonModal(sub)">
                    <span><i class="icon-flag"></i></span>{{ sub.statusId === pspSubscriptionStatusEnum.Suspended ? 'UnFlag' : 'Flag' }}
                  </li>
                  <li *ngIf="showRocheFields(sub.program.companyId);" (click)="openSubscriptionHistoryModal(sub)">
                    <span><i class="icon-history"></i></span> Subscription History
                  </li>
                  <!-- TODO: Remove the comment when api is done
                   <li>
                      <span><i class="icon-key"></i></span>Generate Medicine OTP
                   </li>
                   -->
                  <li [routerLink]="['view-medication-details', sub?.program?.id]" (click)="openMenuItem('active', i)">
                    <span><i class="icon-create"></i></span>View Medication
                    Requests
                  </li>
                  <li (click)="requestHomeDelivery(sub, 'home')">
                    <span><i class="icon-delivery"></i></span>Request Home
                    Delivery
                  </li>
                  <li (click)="requestHomeDelivery(sub,'pickup')">
                    <span><i class="icon-box"></i></span>Request Pick up
                  </li>
                  <li [routerLink]="['/flagging-tracking', sub?.id]" (click)="openMenuItem('active', i)">
                    <span><i class="icon-list"></i></span>View Flagging Tracking
                  </li>
                  <li *ngIf="sub.program?.name =='Fingolidine 0.5mg'" (click)="viewOrEditSubscription(subscriptionArray.active[i])">
                    <span><i class="icon-view"></i></span> View / Edit Active Subscription
                  </li>
                  <li (click)="uploadDocument(sub?.id)">
                    <span><i class="icon-upload-document"></i></span>Upload Documents
                  </li>
                  <li (click)="previewDocument(sub?.id)">
                    <span><i class="icon-preview-document"></i></span>Preview Documents
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row my-2">
              <div class="col-md-6">
                <label for="subDate">Activation Date</label>
                <span id="subDate">{{ sub?.activationDate | date: "MMM d" }}|{{
                  sub?.activationDate | date: "h:mm a"
                  }}</span>
              </div>
              <div class="col-md-6">
                <label for="physName">Physician Name</label>
                <span id="physName">{{ sub?.doctor?.name || "--" }}</span>
              </div>
            </div>
            <div *ngIf="showRocheFields(sub?.program.companyId)">
              <div class="row my-2">
                <div class="col-md-6">
                  <label for="subscription-history" >Subscription History</label>
                  <span id="subscription-history" [title]="(sub?.subscriptionHistory||'')" class="subscription-history"
                  [style.direction]="isArabic(sub?.subscriptionHistory) ? 'rtl' : 'ltr'">{{ sub?.subscriptionHistory || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="psp-code">Psp Code</label>
                  <span id="psp-code">{{ sub?.pspCode || "--" }}</span>
                </div>
              </div>
              <div class="row my-2">
                <div class="col-md-6">
                  <label for="roche-subscription-code">Roche Subscription Code</label>
                  <span id="roche-subscription-code">{{ sub?.doctorCode + '-' + sub?.pspCode || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="doctor-code">Doctor Code</label>
                  <span id="doctor-code">{{ sub?.doctorCode || "--" }}</span>
                </div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-6" *ngIf="!showRocheFields(sub?.program.companyId)">
                <label for="hospital">Hospital/Clinic Name</label>
                <span id="hospital">{{ sub?.hospital?.name || "--" }}</span>
              </div>
              <div class="col-md-6" *ngIf="currentPspType == pspTypeEnum.PspCareGiver">
                <label for="care-receiver-name">Care Receiver Name</label>
                <span id="care-receiver-name">{{ sub?.careReceiverName || "--" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5" *ngIf="subscriptionArray.previous.length > 0">
      <h2>Previous Subscriptions</h2>
      <div class="address-container d-flex flex-wrap">
        <div class="address-card" *ngFor="let sub of subscriptionArray.previous; let i = index">
          <div class="card-header">
            <div class="more-menu-trigger row d-flex justify-content-between pr-3 pl-3">
              <h3>{{ sub?.program.name }}</h3>
              <span (click)="openMenuItem('previous', i)" *ngIf="sub.statusId !== 6">
                <i class="icon-show-more"></i>
              </span>
              <div class="more-menu" *ngIf="moreMenuItems?.previous[i]">
                <ul>
                  <li [routerLink]="['/flagging-tracking', sub?.id]" (click)="openMenuItem('active', i)">
                    <span><i class="icon-list"></i></span>View Flagging Tracking
                  </li>
                  <li *ngIf="showRocheFields(sub.program.companyId);" (click)="openSubscriptionHistoryModal(sub)">
                    <span><i class="icon-history"></i></span> Subscription History
                  </li>
                  <li (click)="previewDocument(sub?.id)">
                    <span><i class="icon-preview-document"></i></span>Preview Documents
                  </li>
                      <!--
                      TODO: Remove the comment when api is done
                      <li> <span><i class="icon-view"></i></span>Reactivation Subscription</li>
                      -->
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row my-2">
              <div class="col-md-6" *ngIf="sub.statusId !== 6">
                <label for="subDate">Deactivation Date</label>
                <span id="subDate">{{ sub?.cancellationDate | date: "MMM d" }}|{{
                  sub?.cancellationDate | date: "h:mm a"
                  }}</span>
              </div>
              <div class="col-md-6" *ngIf="sub.statusId == 6">
                <label for="subDate">Status</label>
                <span id="subDate">Finished</span>
              </div>
              <div class="col-md-6">
                <label for="physName">Physician Name</label>
                <span id="physName">{{ sub?.doctor?.name || "--" }}</span>
              </div>
            </div>
            <div *ngIf="showRocheFields(sub?.program.companyId)">
              <div class="row my-2" >
                <div class="col-md-6">
                  <label for="subscription-history">Subscription History</label>
                  <span id="subscription-history" [title]="(sub?.subscriptionHistory||'')" class="subscription-history"
                  [style.direction]="isArabic(sub?.subscriptionHistory) ? 'rtl' : 'ltr'">{{ sub?.subscriptionHistory || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="psp-code">Psp Code</label>
                  <span id="psp-code">{{ sub?.pspCode || "--" }}</span>
                </div>
              </div>
              <div class="row my-2" >
                <div class="col-md-6">
                  <label for="roche-subscription-code">Roche Subscription Code</label>
                  <span id="roche-subscription-code">{{ sub?.doctorCode + '-' + sub?.pspCode || "--" }}</span>
                </div>
                <div class="col-md-6">
                  <label for="doctor-code">Doctor Code</label>
                  <span id="doctor-code">{{ sub?.doctorCode || "--" }}</span>
                </div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-6" *ngIf="!showRocheFields(sub?.program.companyId)">
                <label for="hospital">Hospital/Clinic Name</label>
                <span id="hospital">{{ sub?.hospital?.name || "--" }}</span>
              </div>
              <div class="col-md-6" *ngIf="currentPspType == pspTypeEnum.PspCareGiver">
                <label for="hospital">Care Receiver Name</label>
                <span id="hospital">{{ sub?.careReceiverName || "--" }}</span>
              </div>
              <div class="col-md-6">
                <label for="companyName">Company Name</label>
                <span id="companyName">{{ sub?.program?.companyName || "" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #addressSubModal>
    <div class="modal-header lookup-header">
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="notificationModal.hide()">
        <span class="close" aria-hidden="true"> × </span>
      </button>
    </div>

    <div class="modal-body add-address-modal mt--3">
      <div class="lookup-card d-flex align-items-center flex-column bg-white" id="cont">
        <h2>Home Delivery Request</h2>
        <p>
          You can choose from previous saved addresses or choose to add a new
          address
        </p>
        <form #addressForm="ngForm" id="form">
          <div class="mt-3" id="saved-address">
            <h2>Saved Addresses</h2>
            <div class="saved-address-container d-flex">
              <div class="address-card" *ngFor="let address of addresses; let i = index">
                <div class="card-header">
                  <div class="more-menu-trigger row d-flex justify-content-start pr-3 pl-3">
                    <span class="select-option mr-1">
                      <input type="radio" name="address-checked" [id]="'address-checked' + i"
                        (change)="onChange(address)" [value]="address.patientAddressId" />
                    </span>
                    <h3 [tooltip]="address?.title">
                      {{
                      address?.title.length > 20
                      ? (address?.title | slice: 0:25) + "..."
                      : address?.title
                      }}
                    </h3>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="city">City</label>
                      <span id="city">{{ address?.cityName }}</span>
                    </div>
                    <div class="col-md-6">
                      <label for="area">Area</label>
                      <span id="area">{{ address?.areaName }}</span>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <label for="address">Address</label>
                      <span id="address">{{ address?.details }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center flex-column">
      <button [ngClass]="{ loading: loading }" type="submit" class="btn btn-psp-primary mb-3 btn-round"
        [disabled]="!selectedAddressForHomeDelivery" (click)="onSubmit()">
        Submit
      </button>
      <span class="link-another color-primary" (click)="onAddNewAddress()">Add New Address</span>
    </div>
  </ng-template>

  <ng-template #otpModal>
    <div class="modal-header lookup-header">
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="notificationModal.hide()">
        <span class="close" aria-hidden="true"> × </span>
      </button>
    </div>

    <div class="modal-body add-address-modal">
      <div class="lookup-card d-flex align-items-center flex-column bg-white" id="cont">
        <span class="header-icon mb-2">
          <i class="icon-correct"></i>
        </span>
        <h2>Request Submitted Successfully!</h2>
        <p>
          An OTP is generated for this request and it’s valid for the next 6
          hours.
        </p>

        <div class="row mt-3">
          <div class="col-md-12">
            <span class="otp" id="otp0">{{ otp[0] }}</span>
            <span class="otp" id="otp1">{{ otp[1] }}</span>
            <span class="otp" id="otp2">{{ otp[2] }}</span>
            <span class="otp" id="otp3">{{ otp[3] }}</span>
            <span class="otp" id="otp4">{{ otp[4] }}</span>
            <span class="otp" id="otp5">{{ otp[5] }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center flex-column">
      <button [ngClass]="{ loading: loading }" type="submit" class="btn btn-psp-primary mb-3 btn-round"
        [disabled]="!selectedAddressForHomeDelivery" (click)="notificationModal.hide()">
        close
      </button>
      <span class="link-another color-psp-primary" (click)="notificationModal.hide()">View Medication Requests</span>
    </div>
  </ng-template>

  <ngx-spinner></ngx-spinner>
</div>
